import { useEffect, useState } from "react";
import { Cookie, ShieldCheck, X } from "@phosphor-icons/react";

const STORAGE_KEY = "caminhos_lgpd_consent_v1";

export default function CookieConsent() {
  const [state, setState] = useState({ show: false, showDetails: false });
  const [prefs, setPrefs] = useState({ essential: true, analytics: false, marketing: false });

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (!saved) setState({ show: true, showDetails: false });
      else setPrefs(JSON.parse(saved));
    } catch {
      setState({ show: true, showDetails: false });
    }
  }, []);

  function accept(all) {
    const p = all
      ? { essential: true, analytics: true, marketing: true }
      : { ...prefs, essential: true };
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...p, ts: new Date().toISOString() }));
    setPrefs(p);
    setState({ show: false, showDetails: false });
  }

  function rejectAll() {
    const p = { essential: true, analytics: false, marketing: false };
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...p, ts: new Date().toISOString() }));
    setPrefs(p);
    setState({ show: false, showDetails: false });
  }

  if (!state.show) return null;

  return (
    <div data-testid="lgpd-banner"
         className="fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:bottom-6 z-[100] max-w-md">
      <div className="card-elevated rounded-3xl p-5 sm:p-6 border border-zinc-200">
        <div className="flex items-start gap-3">
          <div className="w-11 h-11 rounded-2xl gradient-primary flex items-center justify-center flex-shrink-0 shadow-md">
            <Cookie size={20} color="white" weight="fill" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-heading font-black text-base leading-tight text-[#12143A]">Este site usa cookies</div>
            <p className="text-sm text-zinc-600 mt-2 leading-relaxed">
              Utilizamos cookies essenciais para autenticação e funcionamento da plataforma,
              e cookies opcionais para melhorar sua experiência. Ao continuar, você concorda
              com nossa <a href="/privacy" className="text-[#1E5FFF] font-semibold underline">Política de Privacidade</a> conforme a{" "}
              <b>LGPD (Lei 13.709/2018)</b>.
            </p>
          </div>
        </div>

        {state.showDetails && (
          <div className="mt-4 space-y-2 text-sm">
            <label className="flex items-start gap-3 p-3 rounded-2xl bg-zinc-50 opacity-70 cursor-not-allowed">
              <input type="checkbox" checked disabled className="mt-1" />
              <div>
                <div className="font-bold text-[#12143A]">Essenciais <span className="text-[10px] uppercase tracking-widest bg-[#E0EBFF] text-[#1E5FFF] px-1.5 py-0.5 rounded ml-1">Obrigatórios</span></div>
                <div className="text-xs text-zinc-500 mt-0.5">Autenticação, sessão e segurança. Não podem ser desativados.</div>
              </div>
            </label>
            <label className="flex items-start gap-3 p-3 rounded-2xl bg-zinc-50 cursor-pointer hover:bg-zinc-100">
              <input data-testid="cookie-analytics" type="checkbox" checked={prefs.analytics}
                     onChange={e => setPrefs({...prefs, analytics: e.target.checked})} className="mt-1" />
              <div>
                <div className="font-bold text-[#12143A]">Analíticos</div>
                <div className="text-xs text-zinc-500 mt-0.5">Ajudam a entender como você usa a plataforma para melhorá-la.</div>
              </div>
            </label>
            <label className="flex items-start gap-3 p-3 rounded-2xl bg-zinc-50 cursor-pointer hover:bg-zinc-100">
              <input data-testid="cookie-marketing" type="checkbox" checked={prefs.marketing}
                     onChange={e => setPrefs({...prefs, marketing: e.target.checked})} className="mt-1" />
              <div>
                <div className="font-bold text-[#12143A]">Marketing</div>
                <div className="text-xs text-zinc-500 mt-0.5">Personalizam conteúdo e recomendações relevantes ao seu perfil.</div>
              </div>
            </label>
          </div>
        )}

        <div className="mt-4 flex flex-col sm:flex-row gap-2">
          <button data-testid="cookie-reject" onClick={rejectAll}
                  className="btn-pill h-11 px-4 border border-zinc-200 bg-white text-zinc-700 hover:bg-zinc-50 font-semibold text-sm">
            Rejeitar
          </button>
          {state.showDetails ? (
            <button data-testid="cookie-save" onClick={() => accept(false)}
                    className="btn-pill h-11 px-4 flex-1 bg-white border border-[#1E5FFF] text-[#1E5FFF] hover:bg-[#E0EBFF]/30 font-bold text-sm">
              Salvar preferências
            </button>
          ) : (
            <button data-testid="cookie-details" onClick={() => setState(s => ({...s, showDetails: true}))}
                    className="btn-pill h-11 px-4 border border-zinc-200 bg-white text-zinc-700 hover:bg-zinc-50 font-semibold text-sm">
              Personalizar
            </button>
          )}
          <button data-testid="cookie-accept" onClick={() => accept(true)}
                  className="btn-pill h-11 px-5 flex-1 gradient-primary text-white font-bold text-sm shadow-[0_6px_18px_rgba(30,95,255,0.35)]">
            <ShieldCheck size={14} weight="bold" className="inline mr-1" /> Aceitar todos
          </button>
        </div>
      </div>
    </div>
  );
}
